import request from '@/utils/request'


// 查询店铺banner列表
export function listBanner(query) {
  return request({
    url: '/shop/banner/list',
    method: 'get',
    params: query
  })
}

// 查询店铺banner分页
export function pageBanner(query) {
  return request({
    url: '/shop/banner/page',
    method: 'get',
    params: query
  })
}

// 查询店铺banner详细
export function getBanner(data) {
  return request({
    url: '/shop/banner/detail',
    method: 'get',
    params: data
  })
}

// 新增店铺banner
export function addBanner(data) {
  return request({
    url: '/shop/banner/add',
    method: 'post',
    data: data
  })
}

// 修改店铺banner
export function updateBanner(data) {
  return request({
    url: '/shop/banner/edit',
    method: 'post',
    data: data
  })
}

// 删除店铺banner
export function delBanner(data) {
  return request({
    url: '/shop/banner/delete',
    method: 'post',
    data: data
  })
}
